import Index from './Index';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

let Vehicles = (props) => {
  let { path } = useRouteMatch();
  const theme = props.theme;

  return <>
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} ></Index>
      </Route>
    </Switch>
  </>
}

export default Vehicles;
